export default __webpack_public_path__ + "static/hairwash3_soigner-min-79acbe8d698caee6c26ba5c62eadcdf6.png";